import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[iuDynamicContainer]',
})
export class DynamicContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
